import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { InputX, InputRed } from 'components'

const DataSearchError = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: "기관 검색",
			left: "",
			right: <i className="icon icon_close" />
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="padding">
				<div className="form-group search-bar">
					<InputX type="text" defaultValue="시난" placeholder="검색어를 입력해주세요." id="" />
					<i className="icon icon_search" />
				</div>
				<InputRed text="검색어는 최소 2자리 이상 입력해주세요." show={true} />
			</div>
			<div className="center-cont">
				<i className="icon icon_no_data" />
				<p className="mt_20">'시난' 관련 검색 결과가 없어요.<br />
					검색어를 변경해 다시 검색해주세요.
				</p>
			</div>
		</div>
	)
}

export default DataSearchError
